import { VehicleAssignment } from '@fc-core/services/vehicle-assignments.service';

export interface UserPermissions {
  readonly accounting_customer_can_switch_customer_view: boolean;
}

export interface EmployeeGroupPermission {
  id: number;
  name: string;
  description: string;
  isSelected: boolean;
  permissions?: Permission[];
}

export interface Permission {
  id: number;
  name: string;
  fullCodename: keyof UserPermissions;
  codename: string;
}

export interface PermissionState extends Permission {
  active: boolean;
}

export interface EmployeeGroup {
  id?: any;
  name?: string;
  employees?: string[];
  color?: string;
  description?: string;
  visibility?: { vehicles: { all: boolean; groups: number[] } };
}

export interface InvitePayload {
  firstName: string;
  lastName: string;
  email?: string;
  primaryPhoneNumber?: string;
  groups?: number[];
  timezone?: string;
  isOperator?: boolean;
  isAdmin?: boolean;
  streetAddress?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  platformAccess: PlatformAccess[];
  website?: string;
  description?: string;
}

export interface Invite {
  id?: string;
  groups?: number[];
  employee: string;
}

export interface ShortUser {
  id: string;
  email: string;
}

export interface User {
  id?: string;
  lastLogin?: string;
  email?: string;
  pendingEmail?: string;
  isActive?: boolean;
  isStaff?: boolean;
  isSuperuser?: boolean;
  permissions?: Permission[];
  dateJoined?: string;
}

export interface EmployeeOperator {
  id: number;
  isDisabled: boolean;
}

export interface Employee {
  id: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  avatar?: any;
  color?: string;
  customer?: string;
  user?: ShortUser | null;
  email?: string | null;
  primaryPhoneNumber?: string | null;
  secondaryPhoneNumber?: string | null;
  timezone?: string;
  groups?: number[];
  isAdmin?: boolean;
  platformAccess?: PlatformAccess[];
  permissions?: Permission[];
  operator?: EmployeeOperator | null;
  archived?: boolean;
  archivedOn?: string | null;
  archivedBy?: string | null;
  streetAddress?: string | null;
  postalCode?: string | null;
  city?: string | null;
  state?: string | null;
  website?: string | null;
  description?: string | null;
  inviteId?: string | null;
  setstatus?: StatusSet | null;
  birthday?: string | null;
  vehicleAssignment?: VehicleAssignment | null;
  hasInvite?: boolean;
}

export interface EmployeeFilter {
  name: string;
  key: string;
  selected: boolean;
}

export interface UserFilterTypes {
  active: boolean;
  invites: boolean;
  disabled?: boolean;
}

export interface StatusSet {
  id?: number;
  employee?: string;
  status?: string;
  icon?: string;
  duration?: {
    lower?: string;
    upper?: string | null;
    bounds?: string;
  };
  createdBy?: string;
}

export type PlatformAccess = 'console' | 'employee_app' | 'no_access';

export const employeeFields = [
  'id',
  'first_name',
  'last_name',
  'customer',
  'user',
  'full_name',
  'primary_phone_number',
  'secondary_phone_number',
  'timezone',
  'avatar',
  'groups',
  'is_admin',
  'email',
  'operator',
  'archived',
  'archived_on',
  'street_address',
  'postal_code',
  'city',
  'state',
  'website',
  'description',
  'color',
  'permissions',
  'setstatus',
  'platform_access',
  'vehicle_assignment',
];
